{
  "fields": [
    {
      "field": "Weight",
      "valueType": "NumberWithUnit",
      "unit": "kg",
      "step": 0.5,
      "min": 0,
      "max": 2000,
      "progressionStep": 1.25,
      "progressionMin": 0,
      "progressionMax": null,
      "visibleByDefault": true,
      "countsTowardRecords": true,
      "decidesProgression": true,
      "order": 1
    },
    {
      "field": "Reps",
      "valueType": "Integer",
      "unit": null,
      "step": 1,
      "min": 0,
      "max": 10000,
      "progressionStep": 1,
      "progressionMin": 1,
      "progressionMax": 10000,
      "visibleByDefault": true,
      "countsTowardRecords": true,
      "decidesProgression": true,
      "order": 2
    },
    {
      "field": "Duration",
      "valueType": "ElapsedTime",
      "unit": "s",
      "step": 1,
      "min": 0,
      "max": 86400,
      "progressionStep": 1,
      "progressionMin": 1,
      "progressionMax": 86400,
      "visibleByDefault": true,
      "countsTowardRecords": true,
      "decidesProgression": true,
      "order": 3
    },
    {
      "field": "Distance",
      "valueType": "NumberWithUnit",
      "unit": "m",
      "step": 1,
      "min": 0,
      "max": 100000,
      "progressionStep": 1,
      "progressionMin": 1,
      "progressionMax": 100000,
      "visibleByDefault": true,
      "countsTowardRecords": true,
      "decidesProgression": true,
      "order": 4
    },
    {
      "field": "Rounds",
      "valueType": "Integer",
      "unit": null,
      "step": 1,
      "min": 0,
      "max": 10000,
      "progressionStep": 1,
      "progressionMin": 1,
      "progressionMax": 10000,
      "visibleByDefault": true,
      "countsTowardRecords": true,
      "decidesProgression": true,
      "order": 5
    },
    {
      "field": "Speed",
      "valueType": "NumberWithUnit",
      "unit": "km/h",
      "step": 0.1,
      "min": 0,
      "max": 100,
      "progressionStep": 0.1,
      "progressionMin": 0.1,
      "progressionMax": 100,
      "visibleByDefault": true,
      "countsTowardRecords": false,
      "decidesProgression": true,
      "order": 6
    },
    {
      "field": "Rpe",
      "valueType": "BoundedNumberWithStep",
      "unit": null,
      "step": 0.5,
      "min": 0,
      "max": 10,
      "progressionStep": 0.5,
      "progressionMin": 1,
      "progressionMax": 10,
      "visibleByDefault": false,
      "countsTowardRecords": false,
      "decidesProgression": false,
      "order": 7
    },
    {
      "field": "Rir",
      "valueType": "BoundedNumberWithStep",
      "unit": null,
      "step": 1,
      "min": 0,
      "max": 10,
      "progressionStep": 1,
      "progressionMin": 0,
      "progressionMax": 10,
      "visibleByDefault": false,
      "countsTowardRecords": false,
      "decidesProgression": false,
      "order": 8
    },
    {
      "field": "Tempo",
      "valueType": "TextNotation",
      "unit": null,
      "step": null,
      "min": null,
      "max": null,
      "progressionStep": null,
      "progressionMin": null,
      "progressionMax": null,
      "visibleByDefault": false,
      "countsTowardRecords": false,
      "decidesProgression": false,
      "order": 9
    }
  ]
}
